import { arrayOf, bool, number, shape, string } from 'prop-types';

export default shape({
    adsInfo: arrayOf(
        shape({
            product_id: number.isRequired,
            ad_tracking_data: string.isRequired,
        }),
    ),
    isDataFetched: bool,
});
